"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGooglePlacesAutocomplete = void 0;
const js_api_loader_1 = require("@googlemaps/js-api-loader");
const react_1 = require("react");
const use_debounce_1 = require("use-debounce");
const autocompletionRequestBuilder_1 = __importDefault(require("./helpers/autocompletionRequestBuilder"));
const useGooglePlacesAutocomplete = ({ apiKey = '', apiOptions = {}, autocompletionRequest = {}, debounce = 300, minLengthAutocomplete = 0, onLoadFailed = console.error, withSessionToken = false, }) => {
    const [placesService, setPlacesService] = (0, react_1.useState)(undefined);
    const [sessionToken, setSessionToken] = (0, react_1.useState)(undefined);
    const [fetchSuggestions] = (0, use_debounce_1.useDebouncedCallback)((value, cb) => {
        if (!placesService)
            return cb([]);
        if (value.length < minLengthAutocomplete)
            return cb([]);
        const autocompletionReq = { ...autocompletionRequest };
        placesService.getPlacePredictions((0, autocompletionRequestBuilder_1.default)(autocompletionReq, value, withSessionToken && sessionToken), (suggestions) => {
            cb(suggestions || []);
        });
    }, debounce);
    const initializeService = () => {
        if (!window.google)
            throw new Error('[react-google-places-autocomplete]: Google script not loaded');
        if (!window.google.maps)
            throw new Error('[react-google-places-autocomplete]: Google maps script not loaded');
        if (!window.google.maps.places)
            throw new Error('[react-google-places-autocomplete]: Google maps places script not loaded');
        setPlacesService(new window.google.maps.places.AutocompleteService());
        setSessionToken(new google.maps.places.AutocompleteSessionToken());
    };
    (0, react_1.useEffect)(() => {
        const init = async () => {
            try {
                if (!window.google || !window.google.maps || !window.google.maps.places) {
                    await new js_api_loader_1.Loader({ apiKey, ...{ libraries: ['places'], ...apiOptions } }).load();
                }
                initializeService();
            }
            catch (error) {
                onLoadFailed(error);
            }
        };
        if (apiKey)
            init();
        else
            initializeService();
    }, []);
    return [fetchSuggestions, sessionToken, setSessionToken];
};
exports.useGooglePlacesAutocomplete = useGooglePlacesAutocomplete;
